import { render } from "./UserToolbar.vue?vue&type=template&id=5df283e1&scoped=true&ts=true"
import script from "./UserToolbar.vue?vue&type=script&lang=ts"
export * from "./UserToolbar.vue?vue&type=script&lang=ts"

import "./UserToolbar.vue?vue&type=style&index=0&id=5df283e1&lang=scss&scoped=true"

import exportComponent from "/srv/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5df283e1"]])

export default __exports__